import type { Edition } from "~/lib/edition";
import { PageType } from "~/lib/router/enums";

export const pathname = "/home";

const getPageType = (slide: OrUndefined<"main" | "opinion" | "live">) => {
  switch (slide) {
    case "live":
      return PageType.Live;
    case "opinion":
      return PageType.Opinion;
    default:
      return PageType.Homepage;
  }
};

export const page = {
  route(
    query: QueryParameters<{
      edition?: Edition;
      slide?: "main" | "opinion" | "live";
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: getPageType(query.slide) },
    };
  },
  suffix: ["opinion", "live"],
};
